export default __webpack_public_path__ + "static/media/enter-arrow-icon.4fcda196.svg";